import React from 'react';
import { connect } from 'react-redux';

import DefaultEdit from './default-edit';
import { TOPICS } from '../../constants/endpoints';
import { UPDATE_TOPIC } from '../../constants/constants';


function EditTopic({ _id, state, dispatch, title, number, description }){
  const topic_id = _id.$oid;
  const putData = (title, number, description) => ({
    topic: {
      title,
      number,
      description,
    }
  });

  const data = {
    sectionTitle: 'Topic',
    section_id: topic_id,
    endpoint: `${TOPICS}/${topic_id}`,
    action: UPDATE_TOPIC,
    asyncAction: state.asyncAction,
    putData,
    dispatch,
    title,
    number,
    description,
  };

  return (
    <DefaultEdit
      {...data}
    />
  )
}

export default connect(
  nextState => ({ state: nextState }),
)(EditTopic);
